import React, { useRef, useEffect } from "react";
import { Toast } from "primereact/toast";
import "./style.scss";

const AttachmentSuccess = ({ successMsg, setMessages }) => {
  const toast = useRef(null);
  const hasShown = useRef(false);
  const toastLife = 3000;

  useEffect(() => {
    if (successMsg && toast.current && !hasShown.current) {
      hasShown.current = true;

      toast.current.show({
        severity: "success",
        detail: (
          <div className="flex align-items-center justify-content-between">
            <span className="p-message">{successMsg}</span>
          </div>
        ),
        icon: "pi pi-check",
        life: toastLife,
        closable: true,
      });
      setTimeout(() => {
        hasShown.current = false;
        setMessages("");
      }, toastLife + 100);
    }

    if (!successMsg) {
      setMessages("");
      hasShown.current = false;
    }
  }, [successMsg]);

  return successMsg && <Toast ref={toast} position="bottom-right" />;
};

export default AttachmentSuccess;
